import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PeriodSettingsTable(props) {
  var data = props.data,
    columns = props.columns,
    rows = props.rows,
    tdContent = props.tdContent,
    style = props.style,
    styledComponents = props.styledComponents;
  var Th = styledComponents.Th,
    Td = styledComponents.Td;
  var columnKeys = Object.keys(columns);
  var rowKeys = Object.keys(rows);
  var headerColumns = columnKeys.map(function (column) {
    return /*#__PURE__*/_jsx(Th, {
      children: columns[column]
    }, columns[column]);
  });
  var tableContent = rowKeys.map(function (row) {
    var content = columnKeys.map(function (column) {
      return /*#__PURE__*/_jsx(Td, {
        children: tdContent(data, row, column)
      }, columns[column]);
    });
    return /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx(Th, {
        children: rows[row]
      }), content]
    }, rows[row]);
  });
  return /*#__PURE__*/_jsx("table", {
    style: style,
    children: /*#__PURE__*/_jsxs("tbody", {
      children: [/*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx(Th, {}, "row-type"), headerColumns]
      }), tableContent]
    })
  });
}